import React from "react"
import LearnerModal from "./LearnerModal"

export interface LearnerConfirmModalProps {
  isOpen: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  /** Destructive actions (delete) use danger styling. */
  tone?: "danger" | "primary"
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Shared learner confirmation dialog.
 * Built on LearnerModal for portal / escape / overlay behaviour.
 */
const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  tone = "primary",
  isLoading = false,
  onConfirm,
  onCancel,
}: LearnerConfirmModalProps) => (
  <LearnerModal
    isOpen={isOpen}
    title={title}
    description={message}
    isBusy={isLoading}
    onClose={onCancel}
    footer={
      <>
        <button
          type="button"
          className="is-ghost"
          disabled={isLoading}
          onClick={onCancel}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className={tone === "danger" ? "is-danger" : "is-primary"}
          disabled={isLoading}
          onClick={onConfirm}
        >
          {isLoading ? "Please wait…" : confirmLabel}
        </button>
      </>
    }
  />
)

export default ConfirmModal
